import { render, staticRenderFns } from "./Listrequirement.vue?vue&type=template&id=8112e900&scoped=true&"
import script from "./Listrequirement.vue?vue&type=script&lang=js&"
export * from "./Listrequirement.vue?vue&type=script&lang=js&"
import style0 from "./Listrequirement.vue?vue&type=style&index=0&id=8112e900&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8112e900",
  null
  
)

export default component.exports